import { createContext, useContext } from 'react';

/**
 * True inside a standard index table.
 *
 * An index table is a scannable grid: one column, one value. Two-line cells break the
 * alignment that makes a column scannable and hide the second value from sorting, from
 * filtering, and from the column-width controls. Cells read this to refuse the shapes that
 * only make sense elsewhere — a preview table, a modal-embedded table, a card.
 */
export const IndexTableSurfaceContext = createContext(false);

export function useInIndexTable(): boolean {
  return useContext(IndexTableSurfaceContext);
}
